import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

function CV() {
  useEffect(() => {
    window.location.href = 'res/Omar Gamal.pdf';
  }, []);

  return (
    <Helmet>
      <title>ojee / CV / Resume</title>
      <meta name="description" content="Omar Gamal's CV and resume. CSEN graduate, software engineer." />
      <link rel="canonical" href="https://ojee.net/cv" />
    </Helmet>
  );
}

export default CV;